import stickyAddToCartMobile from './mobile';
import stickyAddToCartDesktop from './desktop';

export default () => {
  if (!document.querySelector('body').classList.contains('template-pdp')) {
    return;
  }

  stickyAddToCartMobile();
  stickyAddToCartDesktop();
};
